import axios from 'axios';
import Cookies from 'js-cookie';

const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  // timeout: 10000,
});

axiosInstance.interceptors.request.use((config) => {
  const token = Cookies.get('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
}, Promise.reject);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error),
);

export default axiosInstance;
